// extracted by css-extract-rspack-plugin
export default {"container":"InlineAutocomplete-module__container__NQUmo","fullWidth":"InlineAutocomplete-module__fullWidth__Cph_I"};